import instObj from '@/backend/axios-instances'

const resource = "/notifications/board"
const instance = instObj.baseInstance

export default {
  get(announcementId, parameters) {
    return instance.get(`${resource}/${announcementId}`, { params: parameters });
  },
  put(announcementId, data) {
    return instance.put(`${resource}/${announcementId}`, data);
  },
  delete(announcementId) {
    return instance.delete(`${resource}/${announcementId}`);
  },
  addImage(announcementId, data) {
    return instance.post(`${resource}/${announcementId}/images`, data);
  }
}
